import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-modal',
    templateUrl: './modal.component.html',
    styleUrls: ['./modal.component.scss'],
    standalone: false
})
export class ModalComponent implements OnInit {
  /**
   * Objeto con la info que se vera en el modal
   */
  info: { title: string; message: string } = {} as { title: string; message: string };
  language = 'ES';
  /**
   * Constructor
   *
   * @param dialogRef servicio del modal
   * @param info configuracion e info del modal
   */
  constructor(
    private dialogRef: MatDialogRef<ModalComponent>,
    @Inject(MAT_DIALOG_DATA) private data: any,
  ) {
    this.info = data;
    if (window.navigator.language === 'en-US') {
      this.language = 'EN';
    }
  }

  /**
   * Init
   */
  ngOnInit(): void {
  }

}
